/* CR46 size calculator — faithful port of the live inline version.
   Sizing bands, height nudge and oversized offset are transcribed unchanged. */
(function () {
  'use strict';
  var root = document.querySelector('[data-cr46-calc]');
  if (!root) return;
  // CR48 P12: the old inline calculator (id nm-calc-wrap) is already on this page, so showing
  // this one too would give the shopper two. Hide this one and leave theirs working.
  if (document.getElementById('nm-calc-wrap')) {
    root.hidden = true;
    root.setAttribute('data-cr46-calc-hidden', 'inline-calculator-present');
    return;
  }

  var SIZES = ['S', 'M', 'L', 'XL', '2XL', '3XL'];
  var unit = 'metric';
  var fit = 'fitted';

  var $ = function (sel) { return root.querySelector(sel); };
  var body = $('#cr46-calc-body'), toggle = $('[data-cr46-calc-toggle]'), icon = $('[data-cr46-calc-icon]');
  var wInput = $('[data-cr46-w]'), wLabel = $('[data-cr46-w-label]');
  var hCm = $('[data-cr46-h-cm]'), hFt = $('[data-cr46-h-ft]'), hIn = $('[data-cr46-h-in]');
  var resultEl = $('[data-cr46-result]'), emptyEl = $('[data-cr46-empty]');
  var sizeEl = $('[data-cr46-size]'), noteEl = $('[data-cr46-note]'), fitDesc = $('[data-cr46-fit-desc]');

  // --- transcribed from the live versions, unchanged -----------------------
  // Hoodie: product-template custom liquid "Hoodie Size Calculator" (nmGetFittedIndex).
  // Tee (CR47): product-template custom liquid "T-Shirt Size Calculator" (nmTeeGetFittedIndex).
  var garment = root.getAttribute('data-garment') === 'tee' ? 'tee' : 'hoodie';
  function fittedIndex(wkg) {
    if (garment === 'tee') {
      if (wkg < 50) return 0;
      if (wkg <= 64) return 1;
      if (wkg <= 77) return 2;
      if (wkg <= 90) return 3;
      if (wkg <= 105) return 4;
      return 5;
    }
    if (wkg < 65) return 0;
    if (wkg <= 77) return 1;
    if (wkg <= 86) return 2;
    if (wkg <= 96) return 3;
    if (wkg <= 109) return 4;
    return 5;
  }
  function heightNudge(hcm) {
    if (hcm <= 160) return -1;
    if (hcm >= 190) return 1;
    return 0;
  }
  // -----------------------------------------------------------------------

  function calculate() {
    var hcm, wkg;
    if (unit === 'metric') {
      hcm = parseFloat(hCm.value);
      wkg = parseFloat(wInput.value);
    } else {
      var ft = parseFloat(hFt.value) || 0, inch = parseFloat(hIn.value) || 0;
      hcm = (ft * 12 + inch) * 2.54;
      wkg = (parseFloat(wInput.value) || 0) * 0.4536;
    }
    if (!wkg || wkg < 35) {
      resultEl.hidden = true; emptyEl.hidden = false; if (fitDesc) fitDesc.hidden = false; return;
    }
    var idx = fittedIndex(wkg);
    if (hcm && hcm >= 140) {
      idx = Math.min(Math.max(idx + heightNudge(hcm), 0), SIZES.length - 1);
    }
    if (fit === 'oversized') idx = Math.min(idx + 1, SIZES.length - 1);
    sizeEl.textContent = SIZES[idx];
    noteEl.textContent = fit === 'fitted'
      ? 'Clean fit: structured and close to the body'
      : 'Relaxed fit: roomy with a dropped shoulder';
    resultEl.hidden = false; emptyEl.hidden = true;
    // CR76 r3 (owner): the fit line under the buttons says the same thing as the result note, so while a
    // result is showing only the result's note is shown.
    if (fitDesc) fitDesc.hidden = true;
  }

  toggle.addEventListener('click', function () {
    var open = body.hidden;
    body.hidden = !open;
    toggle.setAttribute('aria-expanded', String(open));
    icon.textContent = open ? '−' : '+';
  });

  // CR76 r3 (owner): "Size guide" beside the size buttons opens this calculator and scrolls to it, instead
  // of jumping to the list of dropdowns below. Capture phase, so the older handler that opens the size-table
  // dropdown (assets/nm-restock.js) doesn't also fire.
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.nm-size-help__link');
    if (!a || root.hidden) return;
    e.preventDefault();
    e.stopPropagation();
    if (body.hidden) toggle.click();
    root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    toggle.focus({ preventScroll: true });
  }, true);

  root.querySelectorAll('[data-cr46-unit]').forEach(function (b) {
    b.addEventListener('click', function () {
      unit = b.getAttribute('data-cr46-unit');
      root.querySelectorAll('[data-cr46-unit]').forEach(function (x) { x.classList.toggle('is-on', x === b); });
      root.querySelector('[data-cr46-height="metric"]').hidden = unit !== 'metric';
      root.querySelector('[data-cr46-height="imperial"]').hidden = unit !== 'imperial';
      wLabel.textContent = unit === 'metric' ? 'KG' : 'LBS';
      wInput.placeholder = unit === 'metric' ? '75' : '165';
      wInput.value = '';
      calculate();
    });
  });

  root.querySelectorAll('[data-cr46-fit]').forEach(function (b) {
    b.addEventListener('click', function () {
      fit = b.getAttribute('data-cr46-fit');
      root.querySelectorAll('[data-cr46-fit]').forEach(function (x) { x.classList.toggle('is-on', x === b); });
      fitDesc.textContent = fit === 'fitted'
        ? 'Clean, structured, sits close to the body'
        : 'Relaxed, dropped shoulder, roomy street look';
      calculate();
    });
  });

  [wInput, hCm, hFt, hIn].forEach(function (el) {
    if (el) el.addEventListener('input', calculate);
  });
})();
